import axios from 'axios';

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const MEDIA_BASE = process.env.REACT_APP_BACKEND_URL;

// Axios instance that injects the auth token from localStorage
export const api = axios.create({ baseURL: API });
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('rgbg_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Resolve a media url that may be relative (/api/uploads/..) to absolute
export const mediaUrl = (url) => {
  if (!url) return '';
  if (url.startsWith('http')) return url;
  return `${MEDIA_BASE}${url}`;
};

// Chunked upload to bypass ingress body-size limits (works for large videos)
const CHUNK_SIZE = 512 * 1024; // 512KB

export async function chunkedUpload(file, meta, onProgress) {
  const media_type = file.type.startsWith('video') ? 'video' : 'image';
  const initRes = await api.post('/media/init', {
    filename: file.name,
    content_type: file.type || 'application/octet-stream',
    media_type,
    category: meta.category || 'Garden',
    title: meta.title || '',
  });
  const uploadId = initRes.data.upload_id;
  const total = file.size;
  let sent = 0;
  for (let start = 0; start < total; start += CHUNK_SIZE) {
    const blob = file.slice(start, Math.min(start + CHUNK_SIZE, total));
    // send raw bytes
    // eslint-disable-next-line no-await-in-loop
    await api.post(`/media/chunk/${uploadId}`, blob, {
      headers: { 'Content-Type': 'application/octet-stream' },
    });
    sent += blob.size;
    if (onProgress) onProgress(Math.round((sent / total) * 100));
  }
  const finishRes = await api.post(`/media/finish/${uploadId}`);
  return finishRes.data;
}
